import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldLooseBase from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
var _queries;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/queryCache.ts
import { hashQueryKeyByOptions, matchQuery } from "./utils.js";
import { Query } from "./query.js";
import { notifyManager } from "./notifyManager.js";
import { Subscribable } from "./subscribable.js";
var QueryCache = (_queries = /*#__PURE__*/_classPrivateFieldLooseKey("queries"), class QueryCache extends Subscribable {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    Object.defineProperty(this, _queries, {
      writable: true,
      value: void 0
    });
    this.config = config;
    _classPrivateFieldLooseBase(this, _queries)[_queries] = /* @__PURE__ */new Map();
  }
  build(client, options, state) {
    var _options$queryHash;
    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) !== null && _options$queryHash !== void 0 ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    let query = this.get(queryHash);
    if (!query) {
      query = new Query({
        client,
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }
    return query;
  }
  add(query) {
    if (!_classPrivateFieldLooseBase(this, _queries)[_queries].has(query.queryHash)) {
      _classPrivateFieldLooseBase(this, _queries)[_queries].set(query.queryHash, query);
      this.notify({
        type: "added",
        query
      });
    }
  }
  remove(query) {
    const queryInMap = _classPrivateFieldLooseBase(this, _queries)[_queries].get(query.queryHash);
    if (queryInMap) {
      query.destroy();
      if (queryInMap === query) {
        _classPrivateFieldLooseBase(this, _queries)[_queries].delete(query.queryHash);
      }
      this.notify({
        type: "removed",
        query
      });
    }
  }
  clear() {
    notifyManager.batch(() => {
      this.getAll().forEach(query => {
        this.remove(query);
      });
    });
  }
  get(queryHash) {
    return _classPrivateFieldLooseBase(this, _queries)[_queries].get(queryHash);
  }
  getAll() {
    return [..._classPrivateFieldLooseBase(this, _queries)[_queries].values()];
  }
  find(filters) {
    const defaultedFilters = _objectSpread({
      exact: true
    }, filters);
    return this.getAll().find(query => matchQuery(defaultedFilters, query));
  }
  findAll() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const queries = this.getAll();
    return Object.keys(filters).length > 0 ? queries.filter(query => matchQuery(filters, query)) : queries;
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }
  onFocus() {
    notifyManager.batch(() => {
      this.getAll().forEach(query => {
        query.onFocus();
      });
    });
  }
  onOnline() {
    notifyManager.batch(() => {
      this.getAll().forEach(query => {
        query.onOnline();
      });
    });
  }
});
export { QueryCache };